var map = {
	"./basketball.webp": 1695,
	"./bti-img.webp": 1696,
	"./bti-title-cn.webp": 1697,
	"./bti-title-en.webp": 1698,
	"./cup.webp": 1699,
	"./football.webp": 1700,
	"./im-img.webp": 1701,
	"./im-title-cn.webp": 1702,
	"./im-title-en.webp": 1703,
	"./imone-img.webp": 1704,
	"./imone-title-cn.webp": 1705,
	"./imone-title-en.webp": 1706,
	"./sb-img.webp": 1707,
	"./sb-title-cn.webp": 1708,
	"./sb-title-en.webp": 1709,
	"./sbo-img.webp": 1710,
	"./sbo-title-cn.webp": 1711,
	"./sbo-title-en.webp": 1712,
	"./sport-bg.webp": 1713,
	"./sport-ctg.webp": 1714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;